import React from 'react';
import type { OnboardingSummary } from '../../../types/onboarding';
import useOnboardingSummary from '../../../hooks/useOnboardingSummary';
import { PiX } from 'react-icons/pi';
import Cash from '../../../assets/images/cash.svg';
import City from '../../../assets/images/city.svg';
import UserCrown from '../../../assets/images/user-crown.svg';

interface NetworkSectionProps {
  section: OnboardingSummary;
}

const NetworkSection = (props: NetworkSectionProps) => {
  const { section } = props;

  const {
    preferredRoles,
    industriesOfInterest,
    connectionFundingStage,
    dealBreakers,
  } = useOnboardingSummary({ section });

  return (
    <div>
      <div className='md:flex gap-6 mb-6'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={UserCrown}
              alt='Preferred roles/title'
            />
            Preferred roles/title
          </div>
          <div className='flex flex-wrap gap-4'>{preferredRoles}</div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={City}
              alt='Industries of interest'
            />
            Industries of interest:
          </div>
          <div className='flex flex-wrap gap-4'>{industriesOfInterest}</div>
        </div>
      </div>

      {connectionFundingStage && (
        <div className='mb-6'>
          <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
            <img
              className='w-6 h-6 object-contain'
              src={Cash}
              alt='Your funding stage'
            />
            Your funding stage:
          </div>
          <div className='text-lg'>{connectionFundingStage}</div>
        </div>
      )}

      <div className='bg-white w-full p-6 rounded-xl'>
        <div className='font-bold text-red-700 mb-4 flex items-center gap-2'>
          <PiX size={22} /> Deal Breakers:
        </div>
        <div className='flex flex-wrap gap-4'>
          <div className='px-5 py-2 bg-red-50 text-red-900 font-medium rounded-xl'>
            {dealBreakers}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkSection;
